import PropTypes from "prop-types"
import React, { useEffect, useState, useMemo } from "react"
import moment from "moment"
import {
  Badge,
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import classNames from "classnames"

//import Charts
import StackedColumnChart from "./StackedColumnChart"
import SplineArea from "./SplineArea"

// //import action
// import { getChartsData as onGetChartsData } from "../../store/actions"

// Image
import modalimage1 from "../../assets/images/product/img-7.png"
import modalimage2 from "../../assets/images/product/img-4.png"

// Pages Components
import WelcomeComp from "./WelcomeComp"
import MonthlyEarning from "./MonthlyEarning"
// import SocialSource from "./SocialSource"
// import ActivityComp from "./ActivityComp"
// import TopCities from "./TopCities"
import IngresosEgresosComponent from "./IngresosEgresos"
import FormasPagoComponent from "./FromasPago"
import PieSegmentosComponent from "./PieSegmentos"
import LatestTranaction from "./LatestTranaction"
import AlumnosSegmentados from "./AlumnosSegmentados"
import Puntualidad from "./Puntualidad"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useDispatch } from "react-redux"

import {
  useCampusVirtualDataDashboardCobranza,
  useCampusVirtualIdCampus,
  useCampusVirtualNombreCampusSeleccionado,
  useCampusVirtualIsLoading,
  useCampusVirtualDataDashboardUltimosRecibos,
  useCampusVirtualDataDashboardCobranzaComparativa,
  useCampusVirtualIngresosEgresos,
  useCampusVirtualIsLoadingUltimosRecibos,
  useCampusVirtualIsLoadingCartera,
  useCampusVirtualDataSegmentos,
  useCampusVirtualAlumnosSegmentados,
  useCampusVirtualIsLoadingDataSegmentos,
  useCampusVirtualIsLoadingAlumnosSegmentados,
  useCampusVirtualMensajeExitoso,
  useCampusVirtualIsLoadingSendLinkPagoEmail,
} from "store/selectors"

import {
  getCampusVirtualCartera as onGetCartera,
  getCampusVirtualCarteraComparativa as onGetCarteraComparativa,
  getCampusVirtualUltimosRecibos as onGetUltimosRecibos,
  getCampusVirtualIngresosEgresos,
  getCampusVirtualDatasegmentos,
  getCampusVirtualAlumnosSegmentados,
  postCampusVirtualSendTemplate,
  unsetCampusVirtualMensajeExito,
  postCampusVirtualSendLinkPagoEmail,
} from "store/actions"
import { data } from "autoprefixer"

import getChartColorsArray from "../../components/Common/ChartsDynamicColor"

const yearData = [
  {
    name: "Pagado",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    name: "xCobrar",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    name: "Cancelado",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
]

const cobranzaComparativaDataInit = [
  {
    name: "2024",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
  {
    name: "2025",
    data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  },
]

const Dashboard = props => {
  //meta title
  document.title = "Dashboard | CampusVirtual"
  //
  const dataColors = '["--bs-primary", "--bs-warning", "--bs-success"]'
  const stackedColumnChartColors = getChartColorsArray(dataColors)

  const dispatch = useDispatch()
  const [totalxCobrarMes, setTotalxCobrarMes] = useState(0)
  const [porcentajeCobradoMes, setPorcentajeCobradoMes] = useState(0)
  const [cobradoMes, setCobradoMes] = useState(0)
  const [ultimosRecibos, setUltimosRecibos] = useState([])

  const dataCobranza = useCampusVirtualDataDashboardCobranza()
  const dataCobranzaComparativa =
    useCampusVirtualDataDashboardCobranzaComparativa()
  const idCampus = useCampusVirtualIdCampus()
  const nombreCampusActual = useCampusVirtualNombreCampusSeleccionado()
  const isLoading = useCampusVirtualIsLoading()
  const isLoadingUltimosRecibos = useCampusVirtualIsLoadingUltimosRecibos()
  const isLoadingSendLinkPagoEmail =
    useCampusVirtualIsLoadingSendLinkPagoEmail()
  const isLoadingCartera = useCampusVirtualIsLoadingCartera()
  const dataUltimosRecibos = useCampusVirtualDataDashboardUltimosRecibos()
  const dataAlumnosSegmentados = useCampusVirtualAlumnosSegmentados()
  const mensajeExito = useCampusVirtualMensajeExitoso()

  const [year, setYear] = useState(new Date().getFullYear())
  const [periodData, setPeriodData] = useState(yearData)
  const [periodType, setPeriodType] = useState("yearly")
  const [cobranzaComparativaData, setCobranzaComparativaData] = useState(
    cobranzaComparativaDataInit
  )
  const [totalRecibos, setTotalRecibos] = useState(0)
  const [porcentajemesAnterior, setPorcentajemesAnterior] = useState(0)
  const [idGrupoServicios, setIidGrupoServicios] = useState(1)

  const optionsCobranza = {
    chart: {
      stacked: !0,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: !0,
      },
    },
    plotOptions: {
      bar: {
        horizontal: !1,
        columnWidth: "25%",
        // endingShape: "rounded"
      },
    },
    dataLabels: {
      enabled: !1,
    },
    yaxis: {
      min: 0, // Asegura que el eje y comience en 0
      max: 100, // Asegura que el eje y termine en 100
      labels: {
        formatter: function (val) {
          return val + "%" // Agrega el símbolo de porcentaje a las etiquetas
        },
      },
    },
    xaxis: {
      show: true,
      categories: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],
      labels: {
        show: true,
      },
    },
    colors: stackedColumnChartColors,
    legend: {
      position: "bottom",
    },
    fill: {
      opacity: 1,
    },
  }

  const columns = useMemo(
    () => [
      {
        header: () => <input type="checkbox" className="form-check-input" />,
        accessorKey: "id_Recibo_Pago",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return <input type="checkbox" className="form-check-input" />
        },
      },
      {
        header: "Folio",
        accessorKey: "Folio_Campus",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <Link to="#" className="text-body fw-bold">
              {cellProps.row.original.Folio_Campus}
            </Link>
          )
        },
      },
      {
        header: "Alumno",
        accessorKey: "Nombre",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Fecha",
        accessorKey: "Fecha_Recibo",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <React.Fragment>
              {moment(cellProps.row.original.Fecha_Recibo).format(
                "DD MMM, YYYY"
              )}
            </React.Fragment>
          )
        },
      },
      {
        header: "Total",
        accessorKey: "Cantidad_Recibo",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <React.Fragment>
              {cellProps.row.original.Cantidad_Recibo.toLocaleString("es-MX", {
                style: "currency",
                currency: "MXN",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
            </React.Fragment>
          )
        },
      },
      {
        header: "Status",
        accessorKey: "Cancelado",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <Badge
              className={
                "font-size-11 badge-soft-" +
                (!cellProps.row.original.Cancelado
                  ? "success"
                  : "danger" && cellProps.row.original.Cancelado === "Cancel"
                  ? "warning"
                  : "danger")
              }
            >
              {!cellProps.row.original.Cancelado ? "Activo" : "Cancelado"}
            </Badge>
          )
        },
      },
      {
        header: "Método Pago",
        accessorKey: "Nombre_Forma_Pago",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <span>
              <i
                className={
                  cellProps.row.original.Nombre_Forma_Pago === "Paypal"
                    ? "fab fa-cc-paypal me-1"
                    : "" || cellProps.row.original.Nombre_Forma_Pago === "COD"
                    ? "fab fas fa-money-bill-alt me-1"
                    : "" ||
                      cellProps.row.original.Nombre_Forma_Pago === "Mastercard"
                    ? "fab fa-cc-mastercard me-1"
                    : "" || cellProps.row.original.Nombre_Forma_Pago === "Visa"
                    ? "fab fa-cc-visa me-1"
                    : ""
                }
              />{" "}
              {cellProps.row.original.Nombre_Forma_Pago}
            </span>
          )
        },
      },
      {
        header: "Detalles",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "view",
        cell: cellProps => {
          return (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={() => toggleViewModal()}
              disabled={true}
            >
              Ver Detalles
            </Button>
          )
        },
      },
    ],
    []
  )

  const sendTemplate = () => {
    dispatch(
      postCampusVirtualSendTemplate({
        TemplateName: "hello_world",
        PhoneNumber: "523314693845",
        languageCode: "en_US",
      })
    )
  }

  const sendLinkPagoEmail = id_Alumno => {
    dispatch(
      postCampusVirtualSendLinkPagoEmail({
        nombreSolicitud: "sendlinkpagoxemail",
        idAlumno: 673,
      })
    )
  }

  const columnsAlumnos = useMemo(
    () => [
      {
        header: () => <input type="checkbox" className="form-check-input" />,
        accessorKey: "id_Alumno",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return <input type="checkbox" className="form-check-input" />
        },
      },
      {
        header: "Alumno",
        accessorKey: "Nombre_Completo",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "Segmento",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <Badge
              className={`font-size-11 badge-soft-${
                cellProps.row.original.Segmento === "Puntual"
                  ? "success"
                  : cellProps.row.original.Segmento ===
                    "Ocasionalmente Atrasado"
                  ? "warning"
                  : "danger"
              }`}
            >
              {cellProps.row.original.Segmento}
            </Badge>
          )
        },
      },
      {
        header: "Nivel de Riesgo",
        accessorKey: "NivelRiesgo",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Monto vencido",
        accessorKey: "MontoTotalVencido",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "# Retrasos",
        accessorKey: "NumeroRetrasos",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Ultimo Pago",
        accessorKey: "UltimoPagoFecha",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <React.Fragment>
              {moment(cellProps.row.original.UltimoPagoFecha).format(
                "DD MMM, YYYY"
              )}
            </React.Fragment>
          )
        },
      },
      {
        header: "Detalles",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "view",
        cell: cellProps => {
          return (
            <>
              <Button
                type="button"
                color="info"
                className="btn-sm btn-rounded m-2"
                onClick={() => toggleViewModal()}
                disabled={true}
              >
                Ver Detalles
              </Button>
              <Button
                type="button"
                color="success"
                className="btn-sm btn-rounded m-2"
                onClick={() => sendTemplate()}
              >
                <i className="bx bxl-whatsapp font-size-16 align-middle me-2"></i>{" "}
                Recordatorio
              </Button>
              <Button
                type="button"
                color="primary"
                className="btn-sm btn-rounded m-2"
                onClick={() => sendLinkPagoEmail()}
              >
                {isLoadingSendLinkPagoEmail ? (
                  <>
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                  </>
                ) : (
                  <>
                    <i className="bx bx-mail-send font-size-16 align-middle me-2"></i>{" "}
                  </>
                )}
                Email
              </Button>
            </>
          )
        },
      },
    ],
    []
  )

  const reports = [
    {
      title: "xCobrar",
      iconClass: "bx-money",
      description: totalxCobrarMes.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }),
    },
    { title: "+30", iconClass: "bx-archive-in", description: "$35, 723" },
    {
      title: "+90",
      iconClass: "bx-error-alt",
      description: "$16.2",
    },
  ]

  const onChangeChartPeriod = pType => {
    setPeriodType(pType)
    setPeriodData(yearData)
    //dispatch(onGetChartsData(pType))
  }

  useEffect(() => {
    console.log("isLoadingSendLinkPagoEmail: ", isLoadingSendLinkPagoEmail)
  }, [isLoadingSendLinkPagoEmail])

  useEffect(() => {
    if (isLoading) {
    }
    if (isLoadingUltimosRecibos) {
      setUltimosRecibos([])
    }
    if (isLoadingCartera) {
      setPeriodData(yearData)
    }
  }, [isLoading, isLoadingUltimosRecibos, isLoadingCartera])

  useEffect(() => {
    if (mensajeExito && mensajeExito.length > 0) {
      toast.success(mensajeExito, {
        autoClose: 2000,
      })
      dispatch(unsetCampusVirtualMensajeExito())
    }
    //
  }, [dispatch, mensajeExito])

  // Ejecutar solo cuando idCampus cambie
  useEffect(() => {
    if (idCampus > 0) {
      dispatch(
        onGetCartera({
          nombreSolicitud: "getcarteraxidgruposervicios",
          sListaIdCampus: idCampus,
          ano: year,
          idGrupoServicios: idGrupoServicios,
        })
      )
      dispatch(
        onGetCarteraComparativa({
          nombreSolicitud: "getcarteracomparativaxidgruposervicios",
          sListaIdCampus: idCampus,
          ano: year,
          idGrupoServicios: idGrupoServicios,
        })
      )
    }
  }, [dispatch, idCampus, year, idGrupoServicios])

  // Ejecutar solo cuando idCampus cambie
  useEffect(() => {
    if (idCampus > 0) {
      dispatch(
        onGetUltimosRecibos({
          nombreSolicitud: "getdataultimosrecibos",
          idCampus: idCampus,
        })
      )
      dispatch(
        getCampusVirtualDatasegmentos({
          nombreSolicitud: "getdatapiesegmentos",
          idCampus: idCampus,
        })
      )
      dispatch(
        getCampusVirtualAlumnosSegmentados({
          nombreSolicitud: "getdatatablealumnossegmentados",
          idCampus: idCampus,
        })
      )
    }
  }, [dispatch, idCampus])

  useEffect(() => {
    if (dataCobranza && dataCobranza.length > 0) {
      const currentMonth = new Date().getMonth() + 1 // Mes actual
      const objMes = dataCobranza.find(objeto => objeto.Mes === currentMonth)

      if (objMes) {
        const meta = objMes.Total_Cantidad - objMes.Total_Cancelados
        const constxPagar = meta - objMes.Total_Saldados
        const porcentajeCobrado = (objMes.Total_Saldados * 100) / meta

        setTotalxCobrarMes(meta | 0)
        setPorcentajeCobradoMes(porcentajeCobrado | 0)
        setCobradoMes(objMes.Total_Saldados | 0)
      } else {
        // Opcional: valores por defecto cuando no hay datos del mes
        setTotalxCobrarMes(0)
        setPorcentajeCobradoMes(0)
        setCobradoMes(0)
      }
    } else {
      // También puedes resetear valores si dataCobranza está vacía
      setTotalxCobrarMes(0)
      setPorcentajeCobradoMes(0)
      setCobradoMes(0)
    }
  }, [dataCobranza])

  useEffect(() => {
    if (Array.isArray(dataCobranza) && dataCobranza.length > 0) {
      // Inicializar los arreglos para cada serie con 12 meses en cero
      let serieA = Array(12).fill(0)
      let serieB = Array(12).fill(0)
      let serieC = Array(12).fill(0)

      // Crear un mapa de datos por mes para acceso rápido
      const dataMap = new Map()
      dataCobranza.forEach(dato => {
        if (dato && typeof dato.Mes === "number") {
          dataMap.set(dato.Mes - 1, dato) // Guardar con índice base 0
        }
      })

      // Rellenar los datos mes a mes, asegurando que la suma sea 100
      for (let i = 0; i < 12; i++) {
        if (dataMap.has(i)) {
          const dato = dataMap.get(i)

          // Validación segura de propiedades numéricas
          const totalCantidad = dato.Total_Cantidad || 1 // Evitar división por cero

          const totalSaldados = dato.Total_Saldados || 0
          const totalCanceladosSaldados = dato.Total_Cancelados_Saldados || 0
          const totalNoSaldados = dato.Total_No_Saldados || 0
          const totalCanceladosNoSaldados =
            dato.Total_Cancelados_No_Saldados || 0
          const totalCancelados = dato.Total_Cancelados || 0

          let pagado =
            ((totalSaldados - totalCanceladosSaldados) / totalCantidad) * 100 ||
            0

          let xCobrar =
            ((totalNoSaldados - totalCanceladosNoSaldados) / totalCantidad) *
              100 || 0

          let cancelado = (totalCancelados / totalCantidad) * 100 || 0

          // Ajuste para que la suma de los porcentajes sea exactamente 100
          let total = pagado + xCobrar + cancelado
          if (total !== 100) {
            const diferencia = 100 - total
            pagado += diferencia // Puedes distribuirlo diferente si lo prefieres
          }

          serieA[i] = parseFloat(pagado.toFixed(2))
          serieB[i] = parseFloat(xCobrar.toFixed(2))
          serieC[i] = parseFloat(cancelado.toFixed(2))
        }
      }

      // Construir el arreglo final
      setPeriodData([
        {
          name: "Pagado",
          data: serieA,
        },
        {
          name: "xCobrar",
          data: serieB,
        },
        {
          name: "Cancelado",
          data: serieC,
        },
      ])
    } else {
      // Si no hay datos, aseguramos limpiar el gráfico con ceros
      setPeriodData([
        { name: "Pagado", data: Array(12).fill(0) },
        { name: "xCobrar", data: Array(12).fill(0) },
        { name: "Cancelado", data: Array(12).fill(0) },
      ])
    }
  }, [dataCobranza])

  useEffect(() => {
    if (
      Array.isArray(dataCobranzaComparativa) &&
      dataCobranzaComparativa.length > 0
    ) {
      let seriepasada = Array(12).fill(0)
      let serieactual = Array(12).fill(0)

      const dataMap = new Map()
      dataCobranzaComparativa.forEach(dato => {
        if (dato && typeof dato.Mes === "number") {
          dataMap.set(dato.Mes - 1, dato)
        }
      })

      for (let i = 0; i < 12; i++) {
        if (dataMap.has(i)) {
          const dato = dataMap.get(i)

          const totalactual = dato.Total_Saldados_Ano || 0
          const totalpasada = dato.Total_Saldados_Ano_Pasado || 0

          seriepasada[i] = parseFloat(totalpasada) || 0
          serieactual[i] = parseFloat(totalactual) || 0
        }
      }

      // Calcular el porcentaje del mes actual comparado con el año pasado
      const mesIndex = new Date().getMonth()
      const mesActual = serieactual[mesIndex] || 0
      const mesAnoAnterior = seriepasada[mesIndex] || 0

      let porcentajeComparado = 0
      if (mesAnoAnterior > 0) {
        porcentajeComparado = (
          (mesActual * 100) / mesAnoAnterior -
          100
        ).toFixed(2)
      }

      setPorcentajemesAnterior(porcentajeComparado)

      setCobranzaComparativaData([
        {
          name: year - 1,
          data: seriepasada,
        },
        {
          name: year,
          data: serieactual,
        },
      ])
    } else {
      // Si no hay datos, inicializar con ceros
      setCobranzaComparativaData([
        {
          name: year - 1,
          data: Array(12).fill(0),
        },
        {
          name: year,
          data: Array(12).fill(0),
        },
      ])
      setPorcentajemesAnterior(0)
    }
  }, [dataCobranzaComparativa])

  useEffect(() => {
    if (Array.isArray(dataUltimosRecibos) && dataUltimosRecibos.length > 0) {
      setUltimosRecibos(dataUltimosRecibos)

      const total = dataUltimosRecibos[0]?.Total_Recibos
      setTotalRecibos(typeof total === "number" ? total : 0)
    } else {
      setUltimosRecibos([])
      setTotalRecibos(0)
    }
  }, [dataUltimosRecibos])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />
          <ToastContainer />
          <Row>
            <Col xl="4">
              <WelcomeComp
                cobrado={cobradoMes}
                noRecibos={totalRecibos || 0}
                isLoading={isLoading}
              />
              <MonthlyEarning
                Total_xCobrar={totalxCobrarMes}
                nombreMes={"Feb"}
                ano={year}
                porcentajeAnoPasado={porcentajemesAnterior}
                porcentaje={porcentajeCobradoMes}
                isLoading={isLoading}
              />{" "}
            </Col>
            <Col xl="8">
              <Row>
                {(reports || [])?.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            {isLoading ? (
                              <React.Fragment>
                                <h4 className="mb-0 placeholder-glow">
                                  <span className="placeholder col-12 placeholder-lg bg-primary"></span>
                                </h4>
                              </React.Fragment>
                            ) : (
                              <h4 className="mb-0">{report.description}</h4>
                            )}

                            {/* <h4 className="mb-0">{report.description}</h4> */}
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i
                                className={
                                  "bx " + report.iconClass + " font-size-24"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>

              <Card>
                <CardBody>
                  <Row>
                    <Col md="3" xs="9">
                      <h5 className="font-size-15 mb-1">
                        Cobranza {nombreCampusActual}
                      </h5>
                      <p className="text-muted mb-0">
                        <div className="input-group input-group-sm">
                          <label className="input-group-text">Concepto</label>
                          <select
                            className="form-select form-select-sm"
                            //value={}
                            onChange={e => {
                              setIidGrupoServicios(e.target.value)
                            }}
                          >
                            <option value="1">Colegiatura</option>
                            <option value="2">Inscripción</option>
                            <option value="3">Recargos</option>
                            <option value="4">ReInscripción</option>
                            <option value="4">Titulación</option>
                            <option value="1,2,4">
                              Colegiatura & Inscripción
                            </option>
                          </select>
                        </div>
                      </p>
                    </Col>
                    <Col md="9" xs="3">
                      <div className="clearfix">
                        <div className="float-end mt-4">
                          <p className="text-muted mb-0">
                            <div className="input-group input-group-sm">
                              <select
                                className="form-select form-select-sm"
                                value={year}
                                onChange={e => {
                                  setYear(parseInt(e.target.value))
                                }}
                              >
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                              </select>
                              <label className="input-group-text">Año</label>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <StackedColumnChart
                      options={optionsCobranza}
                      periodData={periodData}
                    />
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">
                      Cobranza Comparativa {nombreCampusActual}
                    </h4>
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "weekly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              setYear(year - 1)
                            }}
                            id="one_month"
                          >
                            -
                          </Link>{" "}
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "yearly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              onChangeChartPeriod("yearly")
                            }}
                            id="one_month"
                          >
                            {year}
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={classNames(
                              { active: periodType === "monthly" },
                              "nav-link"
                            )}
                            onClick={() => {
                              setYear(year + 1)
                            }}
                            id="one_month"
                          >
                            +
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <SplineArea
                    dataColors='["--bs-primary", "--bs-success"]'
                    series={cobranzaComparativaData}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <IngresosEgresosComponent dataColors='["--bs-primary", "--bs-success"]' />
            </Col>
          </Row>
          <Row>
            <Col xl={4}>
              <FormasPagoComponent dataColors='["--bs-primary", "--bs-success", "--bs-danger", "--bs-warning", "--bs-info", "--bs-dark"]' />
            </Col>
            <Col xl={8}>
              <Puntualidad dataColors='["--bs-primary", "--bs-success", "--bs-danger", "--bs-warning", "--bs-info", "--bs-dark"]' />
            </Col>
          </Row>
          <Row>
            <Col xl={6}></Col>
            <Col xl={6}>
              <PieSegmentosComponent dataColors='["--bs-primary", "--bs-success", "--bs-danger"]' />
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <AlumnosSegmentados
                dataAlumnos={dataAlumnosSegmentados}
                columns={columnsAlumnos}
                isLoading={isLoadingSendLinkPagoEmail}
              />
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <LatestTranaction
                latestTransaction={ultimosRecibos}
                columns={columns}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
